/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdkScanResultModel } from '../../models/sdk-scan-result-model';
import { SessionResultModel } from '../../models/session-result-model';

export interface SessionSubmitSdkSessionPost$Params {
      body?: SdkScanResultModel
}

export function sessionSubmitSdkSessionPost(http: HttpClient, rootUrl: string, params?: SessionSubmitSdkSessionPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<SessionResultModel>> {
  const rb = new RequestBuilder(rootUrl, sessionSubmitSdkSessionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<SessionResultModel>;
    })
  );
}

sessionSubmitSdkSessionPost.PATH = '/Session/SubmitSDKSession';
